import { Button, Text, VStack } from "@chakra-ui/react";
import React, { useState } from "react";
import ProfileSelector from "../../ProfileSelector";
import { ProfileProps } from "../types";
import { motion } from "framer-motion";

const MarketSector: React.FC<ProfileProps> = ({
  defaultValue: { market_sector_id },
  data,
  handleSubmit,
}) => {
  const [optionSelected, setOptionSelected] = useState<string[]>(
    market_sector_id ? [market_sector_id] : []
  );

  return (
    <motion.div
      style={{
        height: "100%",
        margin: 0,
        width: "100%",
        overflow: "auto",
      }}
      initial={{ scale: 0.9 }}
      animate={{ scale: 1 }}
    >
      <VStack h={"100%"} alignItems={"flex-start"}>
        <Text fontFamily={"Raleway"} fontSize={"RH_sm"} fontWeight={600}>
          Qual é o setor de mercado da sua empresa?
        </Text>
        <Text color={"Gray.$700"} fontSize={"L_sm"} fontWeight={400}>
          Selecione em qual segmento de mercado sua empresa se encaixa
        </Text>

        <VStack
          w={"100%"}
          flex={1}
          overflow={"auto"}
          alignItems={"flex-start"}
          mt={"32px !important"}
        >
          <ProfileSelector
            data={data}
            idSelecteds={optionSelected}
            onPress={setOptionSelected}
          />
        </VStack>
        <Button
          variant={"Primary"}
          w={"100%"}
          onClick={() => handleSubmit({ market_sector_id: optionSelected[0] })}
          isDisabled={optionSelected.length < 1}
        >
          Continuar
        </Button>
      </VStack>
    </motion.div>
  );
};

export default MarketSector;
